module.exports = __webpack_public_path__ + "fonts/nunito-sans-latin-300.6ff3f27.woff2";